module.exports = __webpack_public_path__ + "static/media/login_bg.541d087c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tengxian/login_bg.png
// module id = 946
// module chunks = 0